import axios from "axios";
import services from "@/config/services";
import authHeader from "../auth/auth-header";
import Cookies from "js-cookie";
import FileManager from "@/services/ask-file-manager/index.js";

export default class PunService {
  static interceptorSet = false;

  constructor(eventBus) {
    this.eventBus = eventBus;
    this.praticheUrl = `${services.ask_pratiche_base.url}`;
    this.basePath = `${this.praticheUrl}/api/pun`;
    this.filemanager = new FileManager();

    if (!PunService.interceptorSet) {
      axios.interceptors.request.use((req) => {
        req.headers["Authorization"] = authHeader();
        req.headers["Params"] =
          Cookies.get("google_access_token") || Cookies.get("ask_access_token");
        return req;
      });

      PunService.interceptorSet = true;
    }
  }

  toastSuccess(detail, summary = "Operazione completata") {
    this.eventBus?.emit("toast", {
      severity: "success",
      summary,
      detail,
    });
  }

  toastError(detail, summary = "Errore") {
    this.eventBus?.emit("toast", {
      severity: "error",
      summary,
      detail,
    });
  }

  getBackendMessage(err, fallback) {
    return (
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.message ||
      fallback
    );
  }

  async uploadPunFile(file) {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(`${this.basePath}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      this.toastSuccess("File PUN caricato con successo.");
      return res.data;
    } catch (err) {
      this.toastError(this.getBackendMessage(err, "Errore durante il caricamento del file PUN."));
      throw err;
    }
  }

  async getPunRows(params = {}) {
    try {
      const res = await axios.get(`${this.basePath}/rows`, { params });
      return res.data;
    } catch (err) {
      this.toastError(this.getBackendMessage(err, "Errore durante il caricamento dei dati PUN."));
      throw err;
    }
  }

  async getHistory() {
    try {
      const res = await axios.get(`${this.basePath}/history`);
      return res.data;
    } catch (err) {
      this.toastError(this.getBackendMessage(err, "Errore durante il caricamento della cronologia PUN."));
      throw err;
    }
  }

  downloadHistoryFile(item) {
    try {
      if (item?.download_url) {
        window.open(item.download_url, "_blank");
        this.toastSuccess("Download avviato.");
        return;
      }

      if (item?.id) {
        const url = `${this.basePath}/history/${item.id}/download`;
        window.open(url, "_blank");
        this.toastSuccess("Download avviato.");
        return;
      }

      if (item?.path) {
        this.filemanager.download(item.path);
        this.toastSuccess("Download avviato.");
        return;
      }

      this.toastError("Impossibile scaricare: dati file mancanti.");
    } catch (err) {
      this.toastError(this.getBackendMessage(err, "Errore durante il download del file."));
      throw err;
    }
  }
}